export default class Door extends Phaser.Sprite {
    constructor(x, y, vertical, ids) {
        super(game, x, y, 'items');
        this.visible = false;
        this.ids = ids;
        this.frameBase = "door" + (vertical ? 'V' : 'H');
        this.frameName = this.frameBase + "_c.png";

        if (vertical) {
            this.x -= 3;
        } else {
            this.y -= 3;
        }

        this.animations.add("lock", [
            this.frameBase + "_o03.png",
            this.frameBase + "_o02.png",
            this.frameBase + "_o01.png",
            this.frameBase + "_c.png",
            this.frameBase + "_l.png",
        ], 24);
        this.animations.add("unlock", [
            this.frameBase + "_l.png",
            this.frameBase + "_c.png",
            this.frameBase + "_o01.png",
            this.frameBase + "_o02.png",
            this.frameBase + "_o03.png",
        ], 24);
        game.physics.arcade.enableBody(this);
        this.body.enable = false;
        this.body.immovable = true;
        this.locked = false;
        this.rooms = [];
    }

    checkState() {
        let someDisabled = this.rooms.some(r => r.disabled);
        if (someDisabled) this.lock(); else this.unlock();
    }

    lock() {
        if (this.locked) return;
        this.locked = true;
        this.visible = true;
        this.animations.play('lock');
        this.body.enable = true;
    }

    unlock() {
        if (!this.locked) return;
        this.locked = false;
        this.animations.play('unlock').onComplete.addOnce(() => {
            this.visible = false;
        });
        this.body.enable = false;
    }

}


// WEBPACK FOOTER //
// ./src/objects/door.js